import { useCallback, useRef } from 'react';
import { SongFileExtension } from '../../../../../../common/src/model.ts';
import { uploadOrgCustomMusicFile } from '../../../../../../common/src/server_api.ts';
import { alert } from '../../../../util/confirm.tsx';
import { EngineeringButtonWrapper } from '../shared.tsx';

export function UploadButton() {
  const fileChooserInputRef = useRef<HTMLInputElement>(null);

  const onClickUploadMusicXMLFile = useCallback(() => {
    fileChooserInputRef?.current?.click();
  }, [fileChooserInputRef]);

  const getFileInfo = useCallback((): { file: File; orgId: number; songNumber: string } => {
    const file = fileChooserInputRef?.current?.files?.[0];
    if (!file || !file.name.toLowerCase().endsWith('.' + SongFileExtension.Xml)) {
      throw new Error(`Expected a file name ending in .xml`);
    }
    const { orgId, songNumber } = file.name.match(/^(?<orgId>\d+)-(?<songNumber>\d+).*/)?.groups ?? {};
    if (!orgId) {
      throw new Error('Filename not prefixed with org ID');
    }
    return { file, orgId: Number(orgId), songNumber };
  }, [fileChooserInputRef]);

  const onFileChosen = useCallback(async () => {
    try {
      const { file, orgId, songNumber } = getFileInfo();
      await uploadOrgCustomMusicFile({ orgId: orgId, songNumber, file });
      await alert({ confirmation: <span>File upload successful.</span> });
    } catch (error: any) {
      await alert({ confirmation: <span>Error: {error.message}</span> });
    }
  }, [getFileInfo]);

  return (
    <>
      <input type="file" style={{ display: 'none' }} ref={fileChooserInputRef} onChange={onFileChosen} />
      <EngineeringButtonWrapper onClick={onClickUploadMusicXMLFile}>Upload Music XML</EngineeringButtonWrapper>
    </>
  );
}
